import Cookie from 'js-cookie';

const prepareUrl = () => {
  const { protocol, host } = location;
  return encodeURI(`${protocol}//${host}${location.pathname}`);
};

const saveRedirectBackPath = () => {
  localStorage.setItem('popcomics-webreader-back-path', prepareUrl());
};

const saveAction = (action, actionBody) => {
  if (typeof actionBody === 'object') {
    sessionStorage.setItem(action, JSON.stringify(actionBody));
  } else {
    sessionStorage.setItem(action, actionBody);
  }
};

const goToLogin = () => {
  redirect(window.sign_in);
};

const goToLoginWithBackPath = () => {
  saveRedirectBackPath();
  goToLogin();
};

const goToLoginWithAction = (action, actionBody) => {
  saveRedirectBackPath();
  saveAction(action, actionBody);
  goToLogin();
};

const onFB = storyUrl => (
  (event) => {
    event.preventDefault();
    const url = (I18n.locale !== 'en' ? storyUrl.replace('story/', `${I18n.locale}/story/`) : storyUrl);

    FB.ui(
      { method: 'share', display: 'popup', href: url },
      (response) => {
        if (response && !response.error_message) {
          setNoticeSuccess(I18n.t('components.episode_last_page.social_actions.fb.success'));
        } else {
          setNoticeError(I18n.t('components.episode_last_page.social_actions.fb.error'));
        }
      }
    );
  }
);

const isLogged = () => {
  const authToken = Cookie.get('auth_token');
  return typeof authToken !== 'undefined' && authToken !== null;
};
const isNotLogged = () => !isLogged();

const prefix = () => (
  I18n.locale === 'en' ? '' : `/${I18n.locale}`
);

const rootPath = () => (
  `${prefix()}/`
);

const episodePath = (storySlug, episodeSlug) => (
  `${prefix()}/webreader/${storySlug}/${episodeSlug}`
);

const storyPath = storySlug => (
  `${prefix()}/webreader/stories/${storySlug}`
);

const authorPath = authorSlug => (
  `${prefix()}/profile/${authorSlug}`
);

const genrePath = genreSlug => (
  `${prefix()}/genre/${genreSlug}/stream/popular`
);

const enableBrowserFullscreen = () => {
  const docElm = document.documentElement;
  if (docElm.requestFullscreen) {
    docElm.requestFullscreen();
  } else if (docElm.mozRequestFullScreen) {
    docElm.mozRequestFullScreen();
  } else if (docElm.webkitRequestFullScreen) {
    docElm.webkitRequestFullScreen();
  }
};

const disableBrowserFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  }
};

const toggleFullscreenOpacityClasses = (toggleMode) => {
  const header = document.getElementsByTagName('header')[0];
  const headerMenu = document.getElementsByClassName('a-header-menu')[0];
  const scrollreader = document.getElementsByClassName('scrollreader')[0];
  if (header && headerMenu && scrollreader) {
    header.classList[toggleMode]('opacity');
    headerMenu.classList[toggleMode]('opacity');
    scrollreader.classList[toggleMode]('opacity');
  }
};

const toggleBodyScroll = toggleMode => {
  const overflowHiddenClass = 'overflow-hidden';
  const body = document.getElementsByTagName('body')[0];

  body.classList[toggleMode](overflowHiddenClass);
};

const isCurrentEpisodeLast = state => (
  state.episodes.length > 0 &&
  state.currentEpisode.id &&
  state.episodes.findIndex(e => e.id === state.currentEpisode.id) === state.episodes.length - 1
);

const isCurrentEpisodeLocked = state => (
  state.episodes.length > 0 && state.currentEpisode.id &&
  (!state.currentEpisode.paid && state.currentEpisode.episode.premium && state.currentEpisode.episode.price > 0)
);

const areSpecsRunning = () => (
  typeof specsAreRunning !== 'undefined' && specsAreRunning
);

const socialIcons = {
  comment: '/images/webreader/chat-1.svg',
  like: '/images/webreader/like-3.svg',
  liked: '/images/webreader/like-1.svg',
  poppinOff: '/images/webreader/ic-poppin-off.svg',
  poppinOn: '/images/webreader/ic-poppin-on.svg',
  report: '/images/webreader/report.svg',
  default: '/images/sample_images/sample_jpg.jpg',
  share: '/images/webreader/share-1.svg'
};

const modalPaths = {
  signIn: '/sign_in',
  signUp: '/sign_up',
  unlock: '/unlock',
}

export {
  onFB, isLogged, isNotLogged, isCurrentEpisodeLast, isCurrentEpisodeLocked,
  storyPath, rootPath, episodePath, authorPath, genrePath,
  goToLoginWithBackPath, saveAction, goToLoginWithAction,
  enableBrowserFullscreen, disableBrowserFullscreen,
  toggleFullscreenOpacityClasses, toggleBodyScroll,
  areSpecsRunning,
  socialIcons, modalPaths
};
